import {DI_TOKENS} from '@/di/di.tokens';
import {
  FAILED_TO_COPY_DATA_MESSAGE,
  FAILED_TO_SHARE_DATA_MESSAGE,
} from '@/services/ErrorService/ErrorService.constants';
import {ShareState, ShareStatus} from '@/stores/ShareStore/ShareStore.types';

import {injected} from 'brandi';
import copy from 'copy-to-clipboard';

import {FrontendError} from '@/services/ErrorService/FrontendError';
import {LoggerService} from '@/services/LoggerService/LoggerService';
import {GlobalWindow} from '@/types';

export class ShareService {
  constructor(
    private readonly globalWindow: GlobalWindow,
    private readonly loggerService: LoggerService,
  ) {}

  public canShare = (data: ShareData): boolean => {
    // FYI: механизм шера работает только под https
    // @See: https://developer.mozilla.org/en-US/docs/Web/API/Web_Share_API
    const canShare = this.globalWindow.navigator?.canShare?.(data);

    if (canShare === undefined) {
      return false;
    }

    return canShare;
  };

  public share = async (data: ShareData): Promise<ShareState> => {
    try {
      await this.globalWindow.navigator?.share?.(data);

      return {status: ShareStatus.Success};
    } catch (error: unknown) {
      const shareError = FrontendError.createShareError(error as Error, FAILED_TO_SHARE_DATA_MESSAGE);
      this.loggerService.logNativeShareError(shareError);

      // @see: https://stackoverflow.com/questions/60510383/web-share-api-navigator-share-problem-when-canceling-share-dialog-ios-and-androi
      if (error?.toString().includes('AbortError')) {
        return {status: ShareStatus.Aborted, error: shareError};
      } else {
        return {status: ShareStatus.UnknownError, error: shareError};
      }
    }
  };

  public copyToClipboard = (data: string): ShareState => {
    try {
      copy(data);

      return {status: ShareStatus.Success};
    } catch (error: unknown) {
      const copyError = FrontendError.createShareError(error as Error, FAILED_TO_COPY_DATA_MESSAGE);
      this.loggerService.logCopyToClipboardError(copyError);

      return {status: ShareStatus.UnknownError, error: copyError};
    }
  };
}

injected(ShareService, DI_TOKENS.globalWindow, DI_TOKENS.loggerService);
